import { Component } from '@angular/core';

@Component({
  selector: 'app-candidat-layout',
  templateUrl: './candidat-layout.component.html',
  styleUrl: './candidat-layout.component.scss'
})
export class CandidatLayoutComponent {

}
